import React from 'react'
import { Tab as BaseTab, TabProps } from '@mui/base/Tab'
import classes from './Tab.module.scss'

export const Tab = ({ children, ...props }: TabProps) => {
  return (
    <BaseTab className={classes.root} {...props}>
      {children}
    </BaseTab>
  )
}
